import { SortEvent } from 'primeng/api'
import { Injectable } from '@angular/core'

@Injectable()
export class Customsort {
  generalcustomSort(event: SortEvent, list: any) {

   //  alert(event.field);
    // alert(event.field);

    switch (event.field) {
      case 'shortVisitDate':
        if (event.order == -1) {
          list.sort(
            (b, a) =>
              new Date(b.shortVisitDate).getTime() - new Date(a.shortVisitDate).getTime(),
          )
        } else {
          list.sort(
            (a, b) =>
              new Date(b.shortVisitDate).getTime() - new Date(a.shortVisitDate).getTime(),
          )
        }

        break
      case 'onSetDate':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.onSetDate
            var Patient2 = b.onSetDate
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.onSetDate
            var Patient2 = b.onSetDate
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'resolvedDate':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.resolvedDate
            var Patient2 = b.resolvedDate
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.resolvedDate
            var Patient2 = b.resolvedDate
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

        case 'allergyDescription':
            if (event.order == -1) {
                list.sort((a, b) => {
                    var Patient1 = a.allergyDescription
                    var Patient2 = b.allergyDescription
                    return Patient1 > Patient2 ? 1 : -1
                })
            } else {
                list.sort((a, b) => {
                    var Patient1 = a.allergyDescription
                    var Patient2 = b.allergyDescription
                    return Patient1 > Patient2 ? -1 : 1
                })
            }

            break;
        case 'comment':
            if (event.order == -1) {
                list.sort((a, b) => {
                    var Patient1 = a.comment
                    var Patient2 = b.comment
                    return Patient1 > Patient2 ? 1 : -1
                })
            } else {
                list.sort((a, b) => {
                    var Patient1 = a.comment
                    var Patient2 = b.comment
                    return Patient1 > Patient2 ? -1 : 1
                })
            }

            break;
      case 'allergyReaction':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.allergyReaction
            var Patient2 = b.allergyReaction
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.allergyReaction
            var Patient2 = b.allergyReaction
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'providerName':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.providerName
            var Patient2 = b.providerName
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.providerName
            var Patient2 = b.providerName
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

        //case 'diagnosisCodeID':
        //    if (event.order == -1) {
        //        list.sort((a, b) => {
        //            var Patient1 = a.diagnosisCodeID
        //            var Patient2 = b.diagnosisCodeID
        //            return Patient1 > Patient2 ? -1 : 1
        //        })
        //    } else {
        //        list.sort((a, b) => {
        //            var Patient1 = a.diagnosisCodeID
        //            var Patient2 = b.diagnosisCodeID
        //            return Patient1 > Patient2 ? 1 : -1
        //        })
        //    }
        //    break;

        case 'diagnosisCodeID':
            list.sort((a, b) => {
                const code1 = a.diagnosisCodeID?.toString().toLowerCase() || '';
                const code2 = b.diagnosisCodeID?.toString().toLowerCase() || '';

                if (code1 < code2) return event.order === 1 ? -1 : 1;
                if (code1 > code2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;

       
      //case 'problemDescription':
      //  if (event.order == -1) {
      //    list.sort((a, b) => {
      //      var Patient1 = a.problemDescription
      //      var Patient2 = b.problemDescription
      //      return Patient1 > Patient2 ? -1 : 1
      //    })
      //  } else {
      //    list.sort((a, b) => {
      //      var Patient1 = a.problemDescription
      //      var Patient2 = b.problemDescription
      //      return Patient1 > Patient2 ? 1 : -1
      //    })
      //  }

        //  break

        case 'problemDescription':
            list.sort((a, b) => {
                const desc1 = a.problemDescription?.toLowerCase() || '';
                const desc2 = b.problemDescription?.toLowerCase() || '';

                if (desc1 < desc2) return event.order === 1 ? -1 : 1;
                if (desc1 > desc2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;

      //case 'statusDescription':
      //  if (event.order == -1) {
      //    list.sort((a, b) => {
      //      var Patient1 = a.statusDescription
      //      var Patient2 = b.statusDescription
      //      return Patient1 > Patient2 ? -1 : 1
      //    })
      //  } else {
      //    list.sort((a, b) => {
      //      var Patient1 = a.statusDescription
      //      var Patient2 = b.statusDescription
      //      return Patient1 > Patient2 ? 1 : -1
      //    })
      //  }

        //  break

        case 'statusDescription':
            list.sort((a, b) => {
                const status1 = a.statusDescription?.toLowerCase() || '';
                const status2 = b.statusDescription?.toLowerCase() || '';

                if (status1 < status2) return event.order === 1 ? -1 : 1;
                if (status1 > status2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;


        case 'diagnosedDate':
            list.sort((a, b) => {
                const date1 = new Date(a.diagnosedDate).getTime();
                const date2 = new Date(b.diagnosedDate).getTime();

                const isValid1 = !isNaN(date1);
                const isValid2 = !isNaN(date2);

                if (!isValid1 && !isValid2) return 0;                // both invalid, keep same order
                if (!isValid1) return 1;                             // push invalid dates to bottom
                if (!isValid2) return -1;

                return event.order === 1
                    ? date1 - date2
                    : date2 - date1;
            });
            break;

      //case 'diagnosedDate':
      //  if (event.order == -1) {
      //    list.sort((a, b) => {
      //      var Patient1 = a.diagnosedDate
      //      var Patient2 = b.diagnosedDate
      //      return Patient1 > Patient2 ? -1 : 1
      //    })
      //  } else {
      //    list.sort((a, b) => {
      //      var Patient1 = a.diagnosedDate
      //      var Patient2 = b.diagnosedDate
      //      return Patient1 > Patient2 ? 1 : -1
      //    })
      //  }
        //  break

        //case 'diagnosedDate':
        //    list.sort((a, b) => {
        //        const date1 = new Date(a.diagnosedDate).getTime() || 0;
        //        const date2 = new Date(b.diagnosedDate).getTime() || 0;

        //        if (date1 < date2) return event.order === 1 ? -1 : 1;
        //        if (date1 > date2) return event.order === 1 ? 1 : -1;
        //        return 0;
        //    });
        //    break;
      //case 'isResolved':
      //  if (event.order == -1) {
      //    list.sort((a, b) => {
      //      var Patient1 = a.isResolved
      //      var Patient2 = b.isResolved
      //      return Patient1 > Patient2 ? 1 : -1
      //    })
      //  } else {
      //    list.sort((a, b) => {
      //      var Patient1 = a.isResolved
      //      var Patient2 = b.isResolved
      //      return Patient1 > Patient2 ? -1 : 1
      //    })
      //  }
      //  break

        case 'isResolved':
            list.sort((a, b) => {
                const val1 = a.isResolved ? 1 : 0;
                const val2 = b.isResolved ? 1 : 0;

                if (val1 < val2) return event.order === 1 ? -1 : 1;
                if (val1 > val2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;
      case 'shortStartDate':
            list.sort(
                (b, a) => dateComparison(b, a, event)
          )
       

        break
      case 'brandDoseForm':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.brandDoseForm
            var Patient2 = b.brandDoseForm
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.brandDoseForm
            var Patient2 = b.brandDoseForm
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'rxQuanity':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.rxQuanity
            var Patient2 = +b.rxQuanity
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.rxQuanity
            var Patient2 = +b.rxQuanity
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
        case 'rxRefills':
            if (event.order == -1) {
                list.sort((a, b) => {
                    var Patient1 = +a.rxRefills
                    var Patient2 = +b.rxRefills
                    return Patient1 > Patient2 ? 1 : -1
                })
            } else {
                list.sort((a, b) => {
                    var Patient1 = +a.rxRefills
                    var Patient2 = +b.rxRefills
                    return Patient1 > Patient2 ? -1 : 1
                })
            }
            break;  


        case 'shortDateStopped':
                list.sort(
                    (data1, data2) => dateComparison(data1, data2, event));
                
            
            break;
      case 'providerName':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.providerName
            var Patient2 = b.providerName
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.providerName
            var Patient2 = b.providerName
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'visitType':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.visitType
            var Patient2 = b.visitType
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.visitType
            var Patient2 = b.visitType
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'appointmentDetails':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.appointmentDetails
            var Patient2 = b.appointmentDetails
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.appointmentDetails
            var Patient2 = b.appointmentDetails
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'renderingProvider':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.renderingProvider
            var Patient2 = b.renderingProvider
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.renderingProvider
            var Patient2 = b.renderingProvider
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'location':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.location
            var Patient2 = b.location
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.location
            var Patient2 = b.location
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'enDate':
        if (event.order == -1) {
          list.sort(
            (b, a) =>
              new Date(b.enDate).getTime() - new Date(a.enDate).getTime(),
          )
        } else {
          list.sort(
            (a, b) =>
              new Date(b.enDate).getTime() - new Date(a.enDate).getTime(),
          )
        }

        break
      case 'class':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.class
            var Patient2 = b.class
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.class
            var Patient2 = b.class
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'description':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.description
            var Patient2 = b.description
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.description
            var Patient2 = b.description
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'status':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.status
            var Patient2 = b.status
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.status
            var Patient2 = b.status
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'orderedBy':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.orderedBy
            var Patient2 = b.orderedBy
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.orderedBy
            var Patient2 = b.orderedBy
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'date':
        //if (event.order == -1) {
        //  list.sort(
        //    (b, a) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        //  )
        //} else {
        //  list.sort(
        //    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        //  )
            //}


            list.sort((a, b) => {
                const date1 = new Date(a.date).getTime();
                const date2 = new Date(b.date).getTime();

                const isValid1 = !isNaN(date1);
                const isValid2 = !isNaN(date2);

                if (!isValid1 && !isValid2) return 0;                // both invalid, keep same order
                if (!isValid1) return 1;                             // push invalid dates to bottom
                if (!isValid2) return -1;

                return event.order === 1
                    ? date1 - date2
                    : date2 - date1;
            });

        break
      case 'enc_nbr':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.enc_nbr
            var Patient2 = b.enc_nbr
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.enc_nbr
            var Patient2 = b.enc_nbr
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'event_description':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.event_description
            var Patient2 = b.event_description
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.event_description
            var Patient2 = b.event_description
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'sig_msg':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.sig_msg
            var Patient2 = b.sig_msg
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.sig_msg
            var Patient2 = b.sig_msg
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'pre_modification':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.pre_modification
            var Patient2 = b.pre_modification
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.pre_modification
            var Patient2 = b.pre_modification
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'post_modification':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.post_modification
            var Patient2 = b.post_modification
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.post_modification
            var Patient2 = b.post_modification
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'created_by':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.created_by
            var Patient2 = b.created_by
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.created_by
            var Patient2 = b.created_by
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'shortVitalDate':
        if (event.order == -1) {
          list.sort(
            (b, a) =>
              new Date(b.shortVitalDate).getTime() -
              new Date(a.shortVitalDate).getTime(),
          )
        } else {
          list.sort(
            (a, b) =>
              new Date(b.shortVitalDate).getTime() -
              new Date(a.shortVitalDate).getTime(),
          )
        }

        break
      case 'height':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.height
            var Patient2 = +b.height
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.height
            var Patient2 = +b.height
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break
      case 'weight':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.weight
            var Patient2 = +b.weight
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.weight
            var Patient2 = +b.weight
            return Patient1 > Patient2 ? -1 : 1
          })
        }
            break


        case 'bmi': {
            const direction = event.order === -1 ? 1 : -1;
            list.sort((a, b) => {
                const bmi1 = calculateBMI(a);
                const bmi2 = calculateBMI(b);

                // Handle nulls: treat null as greater so they go to the bottom
                if (bmi1 === null && bmi2 === null) return 0;
                if (bmi1 === null) return 1;
                if (bmi2 === null) return -1;

                if (bmi1 === bmi2) return 0;
                return bmi1 > bmi2 ? direction : -direction;
            });
            break;
        }

      //case 'bmi':
      //  if (event.order == -1) {
      //    list.sort((a, b) => {
      //      var Patient1 = a.bmi
      //      var Patient2 = b.bmi
      //      return Patient1 > Patient2 ? 1 : -1
      //    })
      //  } else {
      //    list.sort((a, b) => {
      //      var Patient1 = a.bmi
      //      var Patient2 = b.bmi
      //      return Patient1 > Patient2 ? -1 : 1
      //    })
      //  }
      //  break

      case 'bp':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.bp
            var Patient2 = b.bp
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.bp
            var Patient2 = b.bp
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'pulse':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.pulse
            var Patient2 = +b.pulse
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.pulse
            var Patient2 = +b.pulse
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'temp':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.temp
            var Patient2 = +b.temp
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.temp
            var Patient2 = +b.temp
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'resp':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.resp
            var Patient2 = +b.resp
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.resp
            var Patient2 = +b.resp
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'spo2':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.spo2
            var Patient2 = +b.spo2
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.spo2
            var Patient2 = +b.spo2
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'headCirc':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.headCirc
            var Patient2 = +b.headCirc
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.headCirc
            var Patient2 = +b.headCirc
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'appointmentTime':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.appointmentTime
            var Patient2 = b.appointmentTime
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.appointmentTime
            var Patient2 = b.appointmentTime
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'patientName':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.patientName
            var Patient2 = b.patientName
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.patientName
            var Patient2 = b.patientName
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'appointmentSubject':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.appointmentSubject
            var Patient2 = b.appointmentSubject
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.appointmentSubject
            var Patient2 = b.appointmentSubject
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'appointmentReason':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.appointmentReason
            var Patient2 = b.appointmentReason
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.appointmentReason
            var Patient2 = b.appointmentReason
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'appointmentStatus':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = a.appointmentStatus
            var Patient2 = b.appointmentStatus
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = a.appointmentStatus
            var Patient2 = b.appointmentStatus
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'enCounterNo':
        if (event.order == -1) {
          list.sort((a, b) => {
            var Patient1 = +a.enCounterNo
            var Patient2 = +b.enCounterNo
            return Patient1 > Patient2 ? 1 : -1
          })
        } else {
          list.sort((a, b) => {
            var Patient1 = +a.enCounterNo
            var Patient2 = +b.enCounterNo
            return Patient1 > Patient2 ? -1 : 1
          })
        }
        break

      case 'billableDate':
        if (event.order == -1) {
          list.sort(
            (b, a) =>
              new Date(b.billableDate).getTime() -
              new Date(a.billableDate).getTime(),
          )
        } else {
          list.sort(
            (a, b) =>
              new Date(b.billableDate).getTime() -
              new Date(a.billableDate).getTime(),
          )
        }
        break

        case 'renderingProvider':
            if (event.order == -1) {
                list.sort((a, b) => {
                    var Patient1 = a.renderingProvider
                    var Patient2 = b.renderingProvider
                    return Patient1 > Patient2 ? 1 : -1
                })
            } else {
                list.sort((a, b) => {
                    var Patient1 = a.renderingProvider
                    var Patient2 = b.renderingProvider
                    return Patient1 > Patient2 ? -1 : 1
                })
            }
            break;

        case 'questionDescriptions':
            if (event.order == -1) {
                list.sort((a, b) => {
                    var Patient1 = a.questionDescriptions
                    var Patient2 = b.questionDescriptions
                    return Patient1 > Patient2 ? 1 : -1
                })
            } else {
                list.sort((a, b) => {
                    var Patient1 = a.questionDescriptions
                    var Patient2 = b.questionDescriptions
                    return Patient1 > Patient2 ? -1 : 1
                })
            }

            break;

        case 'lastName':
            list.sort((a, b) => {
                const desc1 = a.lastName?.toLowerCase() || '';
                const desc2 = b.lastName?.toLowerCase() || '';

                if (desc1 < desc2) return event.order === 1 ? -1 : 1;
                if (desc1 > desc2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;

        case 'firstName':
            list.sort((a, b) => {
                const desc1 = a.firstName?.toLowerCase() || '';
                const desc2 = b.firstName?.toLowerCase() || '';

                if (desc1 < desc2) return event.order === 1 ? -1 : 1;
                if (desc1 > desc2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;

        case 'mrn':
            list.sort((a, b) => {
                const desc1 = a.mrn?.toLowerCase() || '';
                const desc2 = b.mrn?.toLowerCase() || '';

                if (desc1 < desc2) return event.order === 1 ? -1 : 1;
                if (desc1 > desc2) return event.order === 1 ? 1 : -1;
                return 0;
            });
            break;

        case 'formattedDOB':
            if (event.order == -1) {
                list.sort(
                    (b, a) =>
                        new Date(b.formattedDOB).getTime() -
                        new Date(a.formattedDOB).getTime(),
                )
            } else {
                list.sort(
                    (a, b) =>
                        new Date(b.formattedDOB).getTime() -
                        new Date(a.formattedDOB).getTime(),
                )
            }
            break;
        case 'formattedArchiveDate':
            if (event.order == -1) {
                list.sort(
                    (b, a) =>
                        new Date(b.formattedArchiveDate).getTime() -
                        new Date(a.formattedArchiveDate).getTime(),
                )
            } else {
                list.sort(
                    (a, b) =>
                        new Date(b.formattedArchiveDate).getTime() -
                        new Date(a.formattedArchiveDate).getTime(),
                )
            }
            break;
            
            

      default: {
        list.sort((a, b) => {
          const patient1 = a[event.field]
          const patient2 = b[event.field]
          const order = event.order === -1 ? 1 : -1
          return patient1 > patient2 ? order : patient1 < patient2 ? -order : 0
        })
      }
    }

    return list
  }
}


function isEmpty(str) {
    return (!str || str.length === 0);
}

function dateComparison(data1,data2,event) {


    let value1 = data1[event.field];
    let value2 = data2[event.field];
    let result = null;

    if (isEmpty(value1) && !isEmpty(value2)) result = -1;
    else if (!isEmpty(value1) && isEmpty(value2)) result = 1;
    else if (isEmpty(value1) && isEmpty(value2)) result = 0;
    else {

        result = new Date(value1) < new Date(value2) ? -1 : new Date(value1) > new Date(value2) ? 1 : 0;


    }

    return result * event.order;

}


function calculateBMI(obj: any): number | null {
    if (!obj) return null;

    const weight = Number(obj.weight);
    const height = Number(obj.height);

    if (!weight || !height || weight <= 0 || height <= 0) {
        return null; // Invalid input, don't calculate
    }

    const chartUnit = (obj.flagHeight?.toUpperCase() === 'IN' && obj.flagWeight?.toUpperCase() === 'LBS')
        ? 'ENGLISH'
        : 'METRIC';

    let bmi: number;

    switch (chartUnit) {
        case 'ENGLISH':
            bmi = (weight / (height * height)) * 703;
            break;
        case 'METRIC':
            const heightInMeters = height / 100;
            bmi = weight / (heightInMeters * heightInMeters);
            break;
        default:
            return null; // Unknown unit
    }

    return Math.round(bmi);
}

